import React from 'react';
import { StyleSheet, View, Pressable, Platform } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

const styles = StyleSheet.create({
  themeBlock: {
    width: 50,
    height: 50,
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 9999,
  },
  themeBlockBtn: {
    display: 'flex',
    height: '100%',
    padding: 2,
    backgroundColor: 'transparent',
    borderRadius: 9999,
    borderWidth: 2,
  },
  themeBlockBtnActive: {
    borderWidth: 2,
  },
  themeBlockName: {
    position: 'absolute',
    bottom: 2,
    left: 0,
    right: 0,
    textAlign: 'center',
  },
  themeBlockInner: {
    display: 'flex',
    height: 42,
    width: 42,
    alignSelf: 'center',
    overflow: 'hidden',
    borderRadius: 9999,
    borderWidth: 1,
  },
  themeCircleLeft: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '50%',
  },
  themeCircleRight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: '50%',
  },
  themeCircleDivider: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '50%',
    width: 2,
    transform: [{ translateX: -1 }],
  },
  themeBlockCheck: {
    position: 'absolute',
    top: -4,
    right: -4,
    width: 20,
    height: 20,
    borderRadius: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  themeBlockCheckMacOS: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
});

function ThemeBlock({ 
  title, 
  value, 
  isActive, 
  onPress,
  colors
}) {
  const { colors: themeColors } = useTheme();

  return (
    <View style={[styles.themeBlock, Platform.OS === 'macos' && { overflow: 'visible' }]}>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={title || value}
        accessibilityState={{ selected: isActive }}
        onPress={() => onPress(value)}
        style={[
          styles.themeBlockBtn,
          { borderColor: themeColors.border_color_secondary },
          isActive && [styles.themeBlockBtnActive, { borderColor: themeColors.accent_color_primary }],
          Platform.OS === 'macos' && { overflow: 'visible' },
        ]}
      >
        <View style={[styles.themeBlockInner, { 
          backgroundColor: colors.solid_color_block,
          borderColor: themeColors.border_color_secondary
        }]}>
          <View style={[styles.themeCircleLeft, { backgroundColor: colors.solid_color_primary }]} />
          <View style={[styles.themeCircleRight, { backgroundColor: colors.solid_color_secondary }]} />
          <View style={[styles.themeCircleDivider, { backgroundColor: colors.border_color_secondary }]} />
        </View>
        {isActive && (
          <View
            pointerEvents="none"
            style={[
              Platform.OS === 'macos' ? styles.themeBlockCheckMacOS : styles.themeBlockCheck,
              Platform.OS !== 'macos' && { backgroundColor: '#1a87ff' },
            ]}
          >
            {Platform.OS === 'macos' ? (
              <View style={{ width: 20, height: 20, borderRadius: 9999, backgroundColor: '#1a87ff', alignItems: 'center', justifyContent: 'center' }}>
                <Icon name="check" size={10} color="#fff" solid />
              </View>
            ) : (
              <Icon name="check" size={10} color="#fff" solid />
            )}
          </View>
        )}
        {/* <Text 
          size="xs" 
          weight={isActive ? 'medium' : 'normal'}
          style={[
            styles.themeBlockName,
          ]}
        >
          {title}
        </Text> */}
      </Pressable>
    </View>
  );
}

export default React.memo(ThemeBlock);